'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _auth = require('./auth.html');

var _auth2 = _interopRequireDefault(_auth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _auth2.default,
  bindings: {
    layout: '@',
    flex: '@'
  },
  controller: function () {
    function AuthComponent() {
      'ngInject';

      _classCallCheck(this, AuthComponent);
    }

    _createClass(AuthComponent, [{
      key: 'getBackgroundImage',
      value: function getBackgroundImage() {
        var imagePaths = ['images/background-horse.jpg', 'images/background-dog.jpg', 'images/background-cat.jpg'];

        var randomImage = imagePaths[Math.floor(Math.random() * imagePaths.length)];
        return randomImage;
      }
    }]);

    return AuthComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/auth/auth.component.js